<script>
  import { Accordion, SectionWrapper } from "paxray-components-svelte";
  import SideKpi from "lib/components/sideKPI.svelte";

  export let title;
  export let description;
</script>

<SectionWrapper fitScreen>
  <div class="ongoing-analysis" slot="main">
    <div class="ongoing-heading">
      <div>
        <span>Continuous monitoring</span>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <span class="status">Ready for connection</span>
    </div>

    <div class="ongoing-empty">
      <span class="pulse" aria-hidden="true" />
      <strong>No on-going data source connected</strong>
      <p>
        This analysis will populate automatically as soon as continuous
        Software Intelligence results are available.
      </p>
    </div>
  </div>

  <div class="ongoing-menu" slot="menu">
    <Accordion heading="Monitoring Status" open>
      <div class="kpis">
        <SideKpi name="Connected sources" value="0" />
        <SideKpi name="Incoming signals" value="0" />
        <SideKpi name="Last update" value="—" />
      </div>
    </Accordion>
    <Accordion heading="Data Scope" open>
      <p>
        On-going uses continuously incoming result data. Transferred project
        data remains available under Projects.
      </p>
    </Accordion>
  </div>
</SectionWrapper>

<style>
  .ongoing-analysis {
    display: flex;
    width: 100%;
    min-width: 0;
    height: 100%;
    flex-direction: column;
    gap: 1rem;
  }

  .ongoing-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
  }

  .ongoing-heading > div {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .ongoing-heading > div > span {
    color: var(--pax-orange);
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  h1 {
    margin: 0;
    font-size: 1.5rem;
  }

  .ongoing-heading p,
  .ongoing-empty p,
  .ongoing-menu p {
    max-width: 42rem;
    margin: 0;
    color: #6f7681;
    font-size: 0.75rem;
    line-height: 1.45;
  }

  .status {
    padding: 0.4rem 0.65rem;
    border-radius: 99px;
    background: #e8e8e8;
    color: #525252;
    font-size: 0.68rem;
    font-weight: 700;
  }

  .ongoing-empty {
    display: flex;
    min-height: 22rem;
    flex: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0.7rem;
    border: 1px dashed #c6c6c6;
    border-radius: 0.5rem;
    background: #fafafa;
    text-align: center;
  }

  .ongoing-empty strong {
    font-size: 1rem;
  }

  .pulse {
    width: 1rem;
    height: 1rem;
    border: 0.3rem solid #ffd7c2;
    border-radius: 50%;
    background: var(--pax-orange);
    box-shadow: 0 0 0 0.45rem #fff0e8;
  }

  .ongoing-menu {
    display: flex;
    height: calc(100vh - 6rem);
    flex-direction: column;
    gap: 1rem;
    overflow-y: auto;
  }

  .kpis {
    display: grid;
    gap: 0.5rem;
  }
</style>
